
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'VersionRisk',
  props: {
    score: {
      type: Number as PropType<number | null>,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    texts: {
      type: Object as PropType<{ [key: number]: string }>,
      required: true
    }
  }
})
